import canvTools from './canvas-tools';
/**
 * Canvas classe parente
 */
export default class CanvasParent {

  canvas = document.createElement('canvas');
  clicked = false;
  mouseIn = false;
  positions = [];
  currentLine = {start: [], end: []}
  newPositions= []
  // valided = false;

  constructor(width, height, id) {
    this.width = this.canvas.width = width;
    this.height = this.canvas.height = height;
    this.id = id;
    this.initCanvas();
  }
  initCanvas = () => {
    document.getElementById('canvas-content').appendChild(this.canvas);
    this.canvas.id = `canvas-${this.id}`;
    this.canvas.style.position = 'absolute';
    this.canvas.style.left = '0';

    this.canvas.addEventListener('mouseenter', this._setMouseIn);
    this.canvas.addEventListener('mouseleave', this._setMouseOut);
    this.offsetLeft = 0;
    this.offsetTop = 0;
    let elem = this.canvas;
    while (elem.offsetParent) {
      this.offsetLeft += elem.offsetLeft;
      this.offsetTop += elem.offsetTop;
      elem = elem.offsetParent;
    }
  }

  findLimitRange = (event) => {
    let canvasHeight = event.target.offsetHeight;
    let canvasWidth = event.target.offsetWidth;
    let topRange = event.offsetY;
    let rightRange = canvasWidth - event.offsetX;
    let bottomRange = canvasHeight - event.offsetY;
    let leftRange = event.offsetX;
    this.limitRange = Math.min(topRange, rightRange, bottomRange, leftRange);
  }

  stopListenMouse = () => {
    this.canvas.removeEventListener('mouseenter', this._setMouseIn);
    this.canvas.removeEventListener('mouseleave', this._setMouseOut);
  }
  initMove = () => {
    this.canvas.addEventListener('mousedown', this._getStartClickMove);
    this.canvas.style.cursor = 'pointer';
  }
  terMove = (id) => {
    this.canvas.removeEventListener('mousedown', this._getStartClickMove);
    this.canvas.style.cursor = 'default';
  }

  _getStartClickMove = (event) => {
    this.clickBeforeMove = {x: event.pageX, y: event.pageY};
    this.extremeDist = canvTools.getMaxRelDist(event, this);
    document.addEventListener('mousemove', this._getNewPos);
    document.addEventListener('mouseup', this._moveToNewPos);
    // window.addEventListener('selectstart', this._disableSelect);
  }
  _disableSelect = (event) => {
    event.preventDefault();
  }
  _getNewPos = (event) => {
    let before = this.clickBeforeMove;
    let newPosX = (event.pageX - before.x);
    let newPosY = (event.pageY - before.y);
    if (newPosX >= this.extremeDist.right)
      newPosX = this.extremeDist.right;
    if (newPosX <= -this.extremeDist.left)
      newPosX = -this.extremeDist.left;
    if (newPosY >= this.extremeDist.bottom)
      newPosY = this.extremeDist.bottom;
    if (newPosY <= -this.extremeDist.top) {
      newPosY = -this.extremeDist.top;
    }
    let relativePos = {x: newPosX, y: newPosY};
    this.newPositions = this.positions.map(({start,end}) => ({
      start: [(start[0] + relativePos.x), (start[1] + relativePos.y)],
      end: [(end[0] + relativePos.x), (end[1] + relativePos.y)],
    }));
    this.draw(this)
    // get this.newPositions && draw();
  }
  _moveToNewPos = (event) => {
    document.removeEventListener('mousemove', this._getNewPos);
    document.removeEventListener('mouseup', this._moveToNewPos);
    // window.removeEventListener('selectstart', this._disableSelect);
    this.positions = this.newPositions
  }

  _setMouseIn = () => this.mouseIn = true;
  _setMouseOut = () => this.mouseIn = false;
}